/**
 * Linear Assets — Work Orders & Incident History (Step 8b)
 */

import React, { useState } from 'react';
import { FileCheck, Download, Lock, CheckCircle2 } from 'lucide-react';
import Card from '../../components/common/Card';
import Button from '../../components/common/Button';
import { reportsApi } from '../../services/api';

export const LinearWorkOrdersPage: React.FC = () => {
  const [workOrders] = useState([
    { id: 'WO-8849', corridor: 'Power Line Sector 7', km: '13.2', crew: 'Alpha Arborist Team', status: 'In Progress', date: '2026-08-16' },
    { id: 'WO-8712', corridor: 'Main Western Rail Line', km: '48.2', crew: 'Emergency Track Gang', status: 'Completed & Sealed', date: '2026-08-15' },
    { id: 'WO-8650', corridor: 'Highland Grid Interconnector', km: '85.1', crew: 'Ground Clearing Unit', status: 'Completed & Sealed', date: '2026-08-10' },
  ]);

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
            <FileCheck className="w-7 h-7 text-amber-500" /> Linear Work Orders &amp; Audit Trail
          </h1>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Immutable log of dispatched vegetation clearance, track obstruction removals, and certified audit records
          </p>
        </div>
      </div>

      <div className="space-y-3">
        {workOrders.map((wo) => (
          <Card key={wo.id} className="p-4 flex flex-wrap items-center justify-between gap-4">
            <div>
              <div className="flex items-center gap-2">
                <span className="font-bold text-sm text-gray-900 dark:text-white">{wo.id}</span>
                <span className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase ${wo.status.includes('Completed') ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-800'}`}>
                  {wo.status}
                </span>
              </div>
              <p className="text-xs text-gray-500 mt-1">
                {wo.corridor} &bull; Km {wo.km} &bull; Assigned: {wo.crew} &bull; {wo.date}
              </p>
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={() => reportsApi.downloadCertifiedPdf('remediation_record', 'lin-cor-01')}
              className="flex items-center gap-1.5"
            >
              <Download className="w-3.5 h-3.5" /> Certified PDF Record
            </Button>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default LinearWorkOrdersPage;
